import ApiService from './ApiService'

export async function apiListMockups(data = {}) {
    return ApiService.fetchData({
        url: '/mockups/list',
        method: 'post',
        data,
    })
}

export async function apiGetMockup(data) {
    return ApiService.fetchData({
        url: '/mockups/get',
        method: 'post',
        data,
    })
}

export async function apiUpsertMockup(data) {
    return ApiService.fetchData({
        url: '/mockups/upsert',
        method: 'post',
        data,
    })
}

export async function apiGenerateMockupRevision(data) {
    return ApiService.fetchData({
        url: '/mockups/revision/generate',
        method: 'post',
        data,
    })
}

export async function apiDeleteMockup(data) {
    return ApiService.fetchData({
        url: '/mockups/delete',
        method: 'post',
        data,
    })
}
